/**
 * Leep Chás — PDP interactions
 */
(function () {
  const productRoot = document.querySelector('[data-pdp-product]');
  if (!productRoot) return;

  const productJsonEl = document.querySelector('[data-product-json]');
  const productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;

  const form = document.querySelector('[data-pdp-form]');
  const variantInput = document.querySelector('[data-pdp-variant-id]');
  const qtyInput = document.querySelector('[data-pdp-qty-input]');
  const priceEl = document.querySelector('[data-pdp-price]');
  const atcBtn = document.querySelector('[data-pdp-atc]');
  const buyNowBtn = document.querySelector('[data-pdp-buy-now]');
  const stickyBar = document.querySelector('[data-pdp-sticky]');

  const getQty = () => Math.max(1, parseInt(qtyInput?.value || '1', 10));

  const getVariantId = () => variantInput?.value || atcBtn?.dataset.variantId;

  const updateVariantUI = (variant) => {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    if (atcBtn) {
      atcBtn.dataset.variantId = variant.id;
      atcBtn.disabled = !variant.available;
    }
    if (buyNowBtn) buyNowBtn.disabled = !variant.available;

    if (stickyBar) {
      const price = stickyBar.querySelector('[data-pdp-sticky-price]');
      if (price && window.Shopify?.formatMoney) {
        price.textContent = Shopify.formatMoney(variant.price);
      }
    }
  };

  /* Gallery */
  const thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));
  const slides = Array.from(document.querySelectorAll('[data-gallery-slide]'));

  const activateSlide = (mediaId) => {
    thumbs.forEach((t) => {
      const active = t.dataset.mediaId === mediaId;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    slides.forEach((slide) => {
      const active = slide.dataset.mediaId === mediaId;
      slide.classList.toggle('is-hidden', !active);
      slide.toggleAttribute('hidden', !active);
    });
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      activateSlide(thumb.dataset.mediaId);
      resetGalleryAutoplay();
    });
  });

  let galleryTimer = null;

  const resetGalleryAutoplay = () => {
    if (galleryTimer) window.clearInterval(galleryTimer);
    if (thumbs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let index = thumbs.findIndex((t) => t.classList.contains('is-active'));
    if (index < 0) index = 0;

    galleryTimer = window.setInterval(() => {
      index = (index + 1) % thumbs.length;
      activateSlide(thumbs[index].dataset.mediaId);
    }, 4500);
  };

  const gallery = document.querySelector('[data-pdp-gallery]');
  if (gallery && thumbs.length > 1) {
    resetGalleryAutoplay();
    gallery.addEventListener('mouseenter', () => {
      if (galleryTimer) window.clearInterval(galleryTimer);
    });
    gallery.addEventListener('mouseleave', resetGalleryAutoplay);
  }

  /* Quantity */
  document.querySelector('[data-pdp-qty-decrease]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = Math.max(1, getQty() - 1);
  });
  document.querySelector('[data-pdp-qty-increase]')?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = getQty() + 1;
  });

  /* Add to cart with quantity */
  atcBtn?.addEventListener('click', async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const variantId = getVariantId();
    if (!variantId || !window.LeepCart) return;
    try {
      await window.LeepCart.add(variantId, getQty(), atcBtn);
    } catch {
      /* cart-drawer shows error */
    }
  });

  /* Buy now */
  buyNowBtn?.addEventListener('click', async () => {
    const variantId = getVariantId();
    if (!variantId) return;
    buyNowBtn.disabled = true;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: getQty() }),
      });
      window.location.href = '/checkout';
    } catch {
      buyNowBtn.disabled = false;
    }
  });

  /* Variant select if present */
  form?.querySelector('select[name="id"]')?.addEventListener('change', (event) => {
    const id = parseInt(event.target.value, 10);
    const variant = productData?.variants?.find((v) => v.id === id);
    updateVariantUI(variant);
  });

  /* Sticky bar — aparece ao rolar para cima, após passar 30% da página */
  if (stickyBar) {
    const minScrollY = document.documentElement.scrollHeight * 0.3;
    let lastY = window.scrollY;

    const onScroll = () => {
      const currentY = window.scrollY;
      const scrollingUp = currentY < lastY;
      lastY = currentY;

      const pastThreshold = currentY > minScrollY;
      const shouldShow = scrollingUp && pastThreshold;
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    stickyBar.querySelector('[data-pdp-sticky-atc]')?.addEventListener('click', async (e) => {
      e.stopPropagation();
      const variantId = getVariantId();
      if (!variantId || !window.LeepCart) return;
      const btn = e.currentTarget;
      try {
        await window.LeepCart.add(variantId, getQty(), btn);
      } catch {
        /* handled inside LeepCart.add */
      }
    });
  }
})();
